import {
    CommonQuery_constants_defaultValues,
    CommonQuery_constants_validation_adGroupConstants,
    CommonQuery_constants_validation_campaignConstants,
    CurrencyCode,
    minusPhraseLibraryConstantsFragment
} from './graphql-grid';

export interface ConstStrategyData {
    maxDailyBudgetChangesPerDay: number;
}

export type ConstCurrencyData = Record<CurrencyCode, CurrencyLimitData> | {};

export interface ConstAlertData {
    enabled: boolean;
    textRu: string | null;
    textEn: string | null;
}

export enum RegionCode {
    RUSSIA = '225',
    UKRAINE = '187',
    BELORUSSIA = '149',
    KAZAKHSTAN = '159',
    UZBEKISTAN = '171',
    GEORGIA = '169',
    CIS = '166',
    MOSCOW_REGION = '1',
    LENINGRAD_REGION = '10174'
}

export interface DailyBudgetLimit {
    minDailyBudget: number;
    maxDailyBudget: number;
}

export interface ConstRelevantPhrasesData {
    minLimit: number;
    maxLimit: number;
}

export interface ConstExperimentsData {
    minRate: number;
    maxRate: number;
    activeExperimentsLimit: number;
}

export interface ConstMetrikaKeyGoalsData {
    minConversion: number;
    maxConversion: number;
}

export interface CurrencyLimitData extends DailyBudgetLimit {
    minPrice: number;
    maxPrice: number;
    bigRate: number;
    defaultPrice: number;
    minCpmPrice: number;
    maxCpmPrice: number;
    autobudgetAvgCpaWarning: number;
    autobudgetAvgPriceWarning: number;
    autobudgetClicksBundleWarning: number;
    autobudgetMaxPriceWarning: number;
    autobudgetSumWarning: number;
    maxAutobudget: number;
    maxAutobudgetBid: number;
    maxAutobudgetClicksBundle: number;
    minAutobudget: number;
    minAutobudgetBid: number;
    minAutobudgetClicksBundle: number;
    minAutobudgetAvgCpa: number;
    minAutobudgetAvgPrice: number;
}

export interface ClientConstData {
    maxGroupsNumberForEditOperation: number;
}

export interface ConstData extends ClientConstData {
    currencyConstants: ConstCurrencyData;
    strategyConstants: ConstStrategyData;
    alertData: ConstAlertData;
    agencyOfflineReportMaximumDate: string;
    minusPhraseLibraryConstants: minusPhraseLibraryConstantsFragment;
    adGroupsConstants: CommonQuery_constants_validation_adGroupConstants;
    campaignConstants: CommonQuery_constants_validation_campaignConstants;
    defaultValues: CommonQuery_constants_defaultValues;
    relevantPhrasesConstants: ConstRelevantPhrasesData;
    experimentsConstants: ConstExperimentsData;
    canvasDomain: string;
    balanceDomain: string;
    spravIFrameUrl: string;
}
